import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Users, Wallet } from "lucide-react";

const REPORTS = [
  {
    to: "/reports/salary",
    icon: Wallet,
    title: "Salary Reports",
    description:
      "Monthly, employee-wise salary summary — logged hours, QuickTime hours, variance, reimbursement, and payable amount. Downloadable as CSV.",
  },
  {
    to: "/reports/team-roster",
    icon: Users,
    title: "Team Overview & Staff Register",
    description:
      "Current and former team members, a monthly hourly-rate timeline, and the full staff register with rate-change history. Downloadable as CSV.",
  },
];

export default function Reports() {
  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Reports</h1>
          <p>Generate and download operational reports.</p>
        </div>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {REPORTS.map(({ to, icon: Icon, title, description }) => (
          <Link key={to} to={to}>
            <Card className="h-full transition-colors hover:bg-muted/50">
              <CardHeader className="flex flex-row items-center gap-3">
                <Icon size={20} />
                <CardTitle className="text-base">{title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>{description}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
